import { memo } from "react";
import { Container } from "./styles";
import { SpacerProps } from "./props.type";

const Spacer = ({ grow, width, height }: SpacerProps) => {
  return <Container $grow={grow} $width={width} $height={height} />;
};

export default memo(Spacer);
